import { StatusLevel } from "../../../types/serviceModuleTypes";

export interface StatusLevelCandidate {
    name: string;
    payoutPoints: number | null;
    minPoints: number | null;
    maxPoints: number | null;
    maxPointsIsOpenEnded: boolean;
}

export interface StatusLevelValidationErrors {
    name?: string;
    payoutPoints?: string;
    minPoints?: string;
    maxPoints?: string;
    range?: string;
}

const rangesOverlap = (
    aMin: number,
    aMax: number | null,
    bMin: number,
    bMax: number | null
): boolean => {
    const aUpper = aMax ?? Number.POSITIVE_INFINITY;
    const bUpper = bMax ?? Number.POSITIVE_INFINITY;
    return aMin <= bUpper && bMin <= aUpper;
};

export const parseIntegerInput = (value: string): number | null => {
    const trimmed = value.trim();
    if (!/^-?\d+$/.test(trimmed)) {
        return null;
    }
    return parseInt(trimmed, 10);
};

export const validateStatusLevel = (
    candidate: StatusLevelCandidate,
    siblings: StatusLevel[]
): StatusLevelValidationErrors => {
    const errors: StatusLevelValidationErrors = {};

    if (candidate.name.trim().length === 0) {
        errors.name = "serviceModulesPage.statusPage.validation.nameRequired";
    } else if (candidate.name.trim().length > 100) {
        errors.name = "serviceModulesPage.statusPage.validation.nameTooLong";
    }

    if (candidate.payoutPoints === null || candidate.payoutPoints < 0) {
        errors.payoutPoints = "serviceModulesPage.statusPage.validation.payoutPointsInvalid";
    }

    if (candidate.minPoints === null) {
        errors.minPoints = "serviceModulesPage.statusPage.validation.minPointsInvalid";
    }

    if (!candidate.maxPointsIsOpenEnded && candidate.maxPoints === null) {
        errors.maxPoints = "serviceModulesPage.statusPage.validation.maxPointsInvalid";
    }

    if (candidate.minPoints !== null && candidate.maxPoints !== null && candidate.maxPoints < candidate.minPoints) {
        errors.maxPoints = "serviceModulesPage.statusPage.validation.maxBelowMin";
    }

    if (candidate.maxPointsIsOpenEnded && siblings.some((level) => level.maxPoints === null)) {
        errors.maxPoints = "serviceModulesPage.statusPage.validation.openLevelExists";
    }

    if (
        !errors.minPoints &&
        !errors.maxPoints &&
        candidate.minPoints !== null &&
        siblings.some((level) =>
            rangesOverlap(candidate.minPoints as number, candidate.maxPoints, level.minPoints, level.maxPoints)
        )
    ) {
        errors.range = "serviceModulesPage.statusPage.validation.rangeOverlap";
    }

    return errors;
};
